/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";

import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { ecosystemSlug, reactSelectStyle } from "Config/Config";

const AssignBulkTaskModal = ({
  moduleName,
  selectedTasks,
  afterCloseModalHandler,
  setBulkSavedTaskList,
  setShowAlert,
  setAlertMessage,
  setMessageType,
  omModalClose = () => {},
}) => {
  const { t } = useTranslation();
  const params = useParams();

  const token = localStorage.getItem("token");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [userInput, setUserInput] = useState("");
  const [userOptions, setuserOptions] = useState([]);
  const [userValue, setUserValue] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState("");

  const [isAdding, setIsAdding] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  /* hooks for validation */
  const [validation, setValidation] = useState({
    userWarning: false,
    taskWarning: false,
  });

  //** Function for Validation */
  const validationHandler = () => {
    let isValid = true;

    if (!userValue) {
      setValidation((prevState) => ({ ...prevState, userWarning: true }));
      isValid = false;
    }

    if (selectedTasks.length <= 0) {
      setValidation((prevState) => ({ ...prevState, taskWarning: true }));
      isValid = false;
    }

    return isValid;
  };

  //function for get user details
  const getUserList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_FOR_TASK +
        `?token=${token}` +
        `&userstring=${userInput}&modulename=${moduleName}`;
      //`&roleslug=${userInfo.role.name}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        if (response.data.length > 0) {
          setuserOptions(response.data);
        }
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for get user input
  const userInputHandler = (val) => {
    setUserInput(val);
    setErrorMessage("");
  };

  //function user Selection
  const userSelectionHandler = (val) => {
    // console.log("select val >> ", val);

    setErrorMessage("");
    if (val) {
      setUserValue(val);
      val._id ? setUserId(val._id) : setUserId(null); // if new user or other than contact user email is added
      val.email ? setUserEmail(val.email) : setUserEmail(val.value); // if new user or other than contact, set value as email
    } else {
      setUserValue(null);
      setUserId(null);
      setUserEmail("");
      setuserOptions([]);
    }
  };

  const assignTaskHandler = async () => {
    if (validationHandler()) {
      setIsAdding(true);
      try {
        let assignTaskData = {
          taskids: selectedTasks,
          assigneduser: userId,
        };

        console.log("assignTaskData---->", assignTaskData);

        let requestUrl =
          url.API_BASE_URL + url.API_ASSIGN_BULK_TASK + `?token=${token}`;

        const response = await postData(requestUrl, assignTaskData);

        setIsAdding(false);

        console.log("response in assign task", response);

        if (response.status) {
          setMessageType("success");
          setBulkSavedTaskList(response.data);
          resetHandler();
          //call member list api function
          afterCloseModalHandler(response.taskresponse);
          omModalClose();

          //hide member modal
          let bootstrapModal = document.querySelector("#addAssingTask");
          let modal = bootstrap.Modal.getInstance(bootstrapModal);
          modal.hide();

          const bootstrapShowModal = new bootstrap.Modal(
            document.getElementById("afterSaveBulkModal")
          );
          bootstrapShowModal.show();
        } else {
          setMessageType("error");
          setErrorMessage(response.message);
        }

        setAlertMessage(response.message);
      } catch (error) {
        setMessageType("error");
        setAlertMessage(error.message);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please fill up required fields");
    }
    setShowAlert(true);
  };

  //function for reset user select
  const resetUserSelect = () => {
    setUserValue(null);
    setuserOptions([]);
  };

  //** Function for reset
  const resetHandler = () => {
    resetUserSelect();
    setUserInput("");
    setUserId(null);
    setUserEmail("");
    setErrorMessage("");
    setValidation({
      userWarning: false,
    });
  };

  useEffect(() => {
    if (userInput.length > 2) {
      getUserList();
    }
  }, [userInput]);

  const optionsToShow = userOptions.length > 0 ? userOptions : [];

  return (
    <div
      className="modal fade"
      id="addAssingTask"
      tabIndex="-1"
      aria-labelledby="addAssingTask"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content bg-white border-0 rounded-15 shadow-lg">
          {/* Enhanced Header with Icon and Gradient Background */}
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  person_add
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-2 text-white mb-0"
                  id="addMemberLabel"
                >
                  {t("Assign Bulk Tasks")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Assign multiple tasks to a user.")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                resetHandler();
                omModalClose();
              }}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              {isAdding && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white bg-opacity-75"
                  style={{ zIndex: 1050 }}
                >
                  <div
                    className="spinner-border text-primary mb-3"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="text-primary fw-semibold">
                    Assigning tasks, please wait...
                  </p>
                </div>
              )}
              <form onSubmit={(e) => e.preventDefault()}>
                {/* ----- user select section start ----- */}
                <div className="form-group mb-4">
                  <label
                    htmlFor="memberName"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Assign app users / contact (search by name, email)")}
                  </label>
                  <div className="d-flex align-items-center">
                    <CreatableSelect
                      isClearable
                      className="w-100"
                      placeholder={t("Search by name, email")}
                      options={optionsToShow}
                      value={userValue}
                      onChange={(val) => {
                        userSelectionHandler(val);
                        setValidation((prevState) => ({
                          ...prevState,
                          userWarning: false,
                        }));
                        setErrorMessage("");
                      }}
                      onInputChange={(val) => {
                        userInputHandler(val);
                        setValidation((prevState) => ({
                          ...prevState,
                          userWarning: false,
                        }));
                        setErrorMessage("");
                      }}
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                  </div>
                  {/* <!-- ========== Start user validation Section ========== --> */}
                  {validation.userWarning && (
                    <p className="text-danger fw-semibold">
                      * {t("Please type or select user name or email")}
                    </p>
                  )}
                  {/* <!-- ========== End user validation Section ========== --> */}

                  {/* <!-- ========== Start task warning Section ========== --> */}
                  {validation.taskWarning && (
                    <p className="text-danger fw-semibold">
                      * {t("Please select tasks")}
                    </p>
                  )}
                  {/* <!-- ========== End task warning Section ========== --> */}
                </div>
                {/* ----- user select section end ----- */}

                {/* <!-- ========== Start info message Section ========== --> */}
                {/* ----- user select section end ----- */}

                {/* 🔹 Task Assign Conditions Message */}
                <div
                  className="alert alert-danger mt-3"
                  role="alert"
                  style={{ borderRadius: "10px" }}
                >
                  <ul className="mb-0 mt-1 ps-3">
                    <li className="d-flex align-items-center gap-2 mb-1">
                      <span className="material-symbols-outlined text-danger fs-6">
                        block
                      </span>
                      {t("The task must not already have an assigned user.")}
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <span className="material-symbols-outlined text-danger fs-6">
                        group
                      </span>
                      {t("The selected user must be a member of the project.")}
                    </li>
                  </ul>
                </div>
                {/* 🔹 End Task Assign Conditions Message */}

                {/* <!-- ========== Start button and error message Section ========== --> */}

                {/* <!-- ========== End info message Section ========== --> */}

                {/* <!-- ========== Start button and error message Section ========== --> */}
                <div className="action d-flex justify-content-end pt-3 border-top mt-4">
                  {/* <!-- ========== Start save button Section ========== --> */}
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={assignTaskHandler}
                    disabled={isAdding ? true : false}
                    style={{
                      cursor: isAdding ? "not-allowed" : "pointer",
                    }}
                  >
                    {isAdding ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t("Assigning...")}
                      </>
                    ) : (
                      <>
                        <span className="material-symbols-outlined me-1">
                          person_add
                        </span>{" "}
                        {t("Assign Tasks")}
                      </>
                    )}
                  </button>
                  {/* <!-- ========== End save button Section ========== --> */}
                </div>
                {/* <!-- ========== End button and error message Section ========== --> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignBulkTaskModal;
